import { render, staticRenderFns } from "./AdminNaehrwerteRezeptur.vue?vue&type=template&id=1dff4311&"
import script from "./AdminNaehrwerteRezeptur.vue?vue&type=script&lang=js&"
export * from "./AdminNaehrwerteRezeptur.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports